// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"286":"b318cef8","607":"bf9acf52"}[chunkId] + ".chunk.css";
};